'use client'

import { NavLink } from 'react-router-dom'

const navItems = [
  { to: '/', label: 'Map Editor' },
  { to: '/assets', label: 'Asset Manager' },
  { to: '/browser', label: 'Asset Browser' },
  { to: '/skiller', label: 'Skiller' },
  { to: '/inventory', label: 'Inventory' },
] as const

export default function EngineNav() {
  return (
    <nav
      className="flex w-full bg-gray-800 border-b border-gray-700 z-10 flex-shrink-0"
      role="navigation"
      aria-label="Main navigation"
    >
      {navItems.map(({ to, label }) => (
        <NavLink
          key={to}
          to={to}
          end={to === '/'}
          className={({ isActive }) =>
            `flex-1 min-w-0 flex items-center justify-center py-2.5 px-2 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-purple-500 truncate ${
              isActive ? 'bg-purple-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'
            }`
          }
        >
          <span className="truncate">{label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
